import { createSelector } from '@ngrx/store';
import { getMenuState, MenuState } from '../menu.reducer';
import { adapter, ChangeSetsState } from './change-sets.reducer';
import {asyncActionState} from '@emm/core/util/async-action-state';

const getState = createSelector(getMenuState, (state: MenuState) => state.changeSets);

const entitySelectors = adapter.getSelectors(getState);
const asyncActionStateSelectors = asyncActionState.getSelectors(getState);

const getSelectedId = createSelector(getState, (state: ChangeSetsState) => state.selectedId);
const getSelected = createSelector(
    entitySelectors.selectEntities,
    getSelectedId,
    (entities, selectedId) => selectedId && entities[selectedId]
);
const getValidAll = createSelector(
    entitySelectors.selectAll,
    asyncActionStateSelectors.getError,
    asyncActionStateSelectors.getSuccess,
    (items, hasError, success) => (!hasError && success ? items : null)
);

export const ChangeSetsSelectors = {
      entitySelectors,
      ...asyncActionStateSelectors,
      getSelectedId,
      getSelected,
      getValidAll
};
